import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/how-to-tips',
    name: 'how-to-tips',
    meta: {
      title: 'How to Tips'
    },
    component: () => import('@/views/how-to-tips/HowToTipsListView.vue')
  },
  {
    path: '/how-to-tips/create',
    name: 'how-to-tips-create',
    meta: {
      title: 'Create How to Tips'
    },
    component: () => import('@/views/how-to-tips/HowToTipsCreateView.vue')
  },
  {
    path: '/how-to-tips/:id',
    name: 'how-to-tips-edit',
    props: true,
    meta: {
      title: 'Edit How to Tips'
    },
    redirect: ({ params }) => {
      return {
        name: 'how-to-tips-edit-section',
        params: {
          ...params,
          section: 'info'
        }
      }
    },
    component: () => import('@/views/how-to-tips/HowToTipsEditView.vue'),
    children: [
      {
        path: '/how-to-tips/:id/f/:section/:action/:actionId',
        name: 'how-to-tips-edit-section-action',
        props: true,
        meta: {
          title: 'Edit How to Tip'
        },
        component: () => import('@/views/how-to-tips/HowToTipsEditView.vue')
      },
      {
        path: '/how-to-tips/:id/f/:section',
        name: 'how-to-tips-edit-section',
        props: true,
        meta: {
          title: 'Edit How to Tip'
        },
        component: () => import('@/views/how-to-tips/HowToTipsEditView.vue')
      }
    ]
  }
]

export default routes
